import { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";

import { useUserStore } from "../../store/userStore";
import { osPlatform } from "../../store/GlobalVarriables";
import { useIsPWAInstalled } from "../../hooks/useIsPWAInstalled";
import CustomButton from "../CustomButton";

import "./style.scss";

const AddToHome = () => {
  const [promptToggle, setPromptToggle] = useState("disabled");
  const [prompt, setPrompt] = useState(null);
  const { pathname } = useLocation();
  const { t } = useTranslation();
  const isPWA = useIsPWAInstalled();
  const { user } = useUserStore();

  let modalStorage =
    "M0M2MiLCJlbWFpbCI6ImFsZXhAZ21haWwuY29tIiwidWkIjoiMSIsInJvbGVzIjoi";

  useEffect(() => {
    const handleLocalStorageChange = () => {
      const hidePrompt = !!localStorage.getItem("ps10003000");

      if (hidePrompt) {
        setPromptToggle("disabled");
      } else {
        setPromptToggle("prompt");
      }
    };

    window.addEventListener("localStorageChangedPwa", handleLocalStorageChange);
    return () => {
      window.removeEventListener(
        "localStorageChangedPwa",
        handleLocalStorageChange,
      );
    };
  }, []);

  useEffect(() => {
    const handler = (event) => {
      setPrompt(event);
    };

    window.addEventListener("beforeinstallprompt", handler);

    return () => {
      window.removeEventListener("beforeinstallprompt", handler);
    };
  }, []);

  const handleAddToHomeScreenClick = () => {
    if (prompt) {
      prompt.prompt();
    }

    setPromptToggle("disabled");
    localStorage.setItem("ps10003000", modalStorage);
    window.dispatchEvent(new Event("localStorageChangedPwa"));
  };

  const handleClose = () => {
    const dontAsk = !!localStorage.getItem("ps10003000");
    localStorage.removeItem(`requestNotificationPermission${user?.type}`);
    setPromptToggle("disabled");
    if (dontAsk) window.dispatchEvent(new Event("localStorageChangedPwa"));
  };

  if (isPWA) {
    return;
  }

  if (localStorage.ps10003000) {
    return;
  }

  if (!localStorage.ps10005000) {
    return;
  }

  return (
    <div className={`install-modal-container ${promptToggle}`}>
      <div className="install-modal">
        {osPlatform == "iOS" ? (
          <>
            <div className="install-modal-text">
              <h1>{t("pwa_install")}</h1>

              <h2>{t("pwa_install_info")}</h2>
            </div>
            {pathname === "/profile" && (
              <p className="warning-note">
                <strong>{t("note")}</strong>
                {t("pwa_note_message")}
              </p>
            )}

            <div className="install-ios-steps">
              <ol>
                <li>
                  <div>
                    <span> {t("pwa_install_ios_step1")}</span>
                  </div>
                </li>
                <li>
                  <div>
                    <span>{t("pwa_install_ios_step2")}</span>
                  </div>
                </li>
                <li>
                  <div>
                    <span>{t("pwa_install_ios_step3")}</span>
                  </div>
                </li>
              </ol>
            </div>
            <div className="modal-buttons-container">
              <div className="no-ask">
                <input
                  type="checkbox"
                  id="ask"
                  onChange={(e) => {
                    if (e.target.checked) {
                      localStorage.setItem("ps10003000", modalStorage);
                    } else {
                      localStorage.removeItem("ps10003000");
                    }
                  }}
                />
                <label htmlFor="ask">{t("dont_ask_again")}</label>
              </div>
              <CustomButton
                color="error"
                id="modal-cancel"
                onClick={handleClose}
              >
                {t("close")}
              </CustomButton>
            </div>
          </>
        ) : null}

        {osPlatform === "iOS" ? null : (
          <>
            <div className="install-modal-text">
              <h1>{t("pwa_install")}</h1>
              <h2>{t("pwa_install_info")}</h2>
            </div>

            {pathname === "/profile" && (
              <p className="warning-note">
                <strong>{t("note")}</strong>
                {t("pwa_note_message")}
              </p>
            )}

            <div className="modal-buttons-container">
              <div className="modal-action-buttons">
                <CustomButton
                  color="error"
                  id="modal-cancel"
                  onClick={handleClose}
                >
                  {t("close")}
                </CustomButton>
                <CustomButton
                  id="modal-install"
                  onClick={handleAddToHomeScreenClick}
                >
                  {t("pwa_install")}
                </CustomButton>
              </div>

              <div className="no-ask">
                <input
                  type="checkbox"
                  id="ask"
                  onChange={(e) => {
                    if (e.target.checked) {
                      localStorage.setItem("ps10003000", modalStorage);
                    } else {
                      localStorage.removeItem("ps10003000");
                    }
                  }}
                />
                <label htmlFor="ask">{t("dont_ask_again")}</label>
              </div>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default AddToHome;
